import { AQA_ELEMENTS_MARKER_LIST } from 'features/order-tracker/utils/aqaElementsIDList';

export const INPUT_PLACEHOLDER_BY_ID = {
  [AQA_ELEMENTS_MARKER_LIST.entryPage.ornInput]: 'Enter order number',
  [AQA_ELEMENTS_MARKER_LIST.entryPage.pcodeInput]: 'Enter billing address postcode',
};
